import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { eventListingCategories } from '@/helpers/Categories';
import { config } from '@/helpers/Environment';
import { alterQueryParam } from '@/helpers/QueryStringParameters';
@Component({
    name: 'CategoryFilters',
})
export default class default_1 extends Vue {
    @Prop({ default: null })
    value;
    @Prop({ required: true })
    templates;
    showButtons = true;
    @Watch('links')
    onLinksChanged() {
        if (this.links.length > 1) {
            // $nextTick required to check height after elements render.
            this.$nextTick(() => {
                const filterButtons = Array.from(this.$el.querySelectorAll('button.filter'));
                const yPositions = new Set(filterButtons.map((el) => el.getBoundingClientRect().y));
                // When there are more than 2 rows switch to using a `select`.
                if (yPositions.size > 2) {
                    this.showButtons = false;
                }
            });
        }
    }
    get links() {
        const all = this.filterLocation(null, this.t.all);
        const categories = this.categories
            .filter((c) => c.length > 0)
            .map((category) => this.filterLocation(category, category));
        if (categories.length > 1) {
            return [all].concat(categories);
        }
        else {
            return [];
        }
    }
    get categories() {
        return eventListingCategories(this.templates, config.event_categories);
    }
    filterLocation(value, label) {
        return {
            value,
            label,
            location: alterQueryParam(this.$route, { category: value }),
        };
    }
    handleLinkChange(e) {
        const link = this.links.find((link) => link.value === e.target.value);
        if (link) {
            this.$router.push(link.location);
        }
        else {
            this.$router.replace({ query: { category: '' } });
        }
    }
    get currentValue() {
        return this.$route.query.category;
    }
}
